'use strict';

(function ($, Drupal) {
    function closeMegaMenuScrollDown() {
        var openedDesktopMegaMenu = $('li.menu-item--mega .c-mega-menu__active');
        if (openedDesktopMegaMenu) {
            var menuContentDivs = $('li.menu-item--mega .c-mega-menu__active');
            openedDesktopMegaMenu.removeClass('c-mega-menu__active').addClass('c-mega-menu__inactive');
        }
    }

    function determineMobileViewport() {
        if (window.innerWidth < 768) {
            return true;
        }
        return false;
    }

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        var openedMegaMenus = $('.menu-item--mega .c-mega-menu__active');
        var isMobileViewport = determineMobileViewport();
        if (openedMegaMenus.length && isMobileViewport) {
            return;
        }

        if (st > lastScrollTop) {
            closeMegaMenuScrollDown();
        }
        lastScrollTop = st;
    });
})(jQuery, Drupal);
(function ($) {
    $(document).ready(function () {
        var megaMenuBtns = $('li.menu-item--mega button');
        var callBtn = $('li.menu-item--expanded.call button');
        var megaMenuCloseBtns = $('li.menu-item--mega .c-mega-menu__top .c-mega-menu__close');

        // The Mega Menu items only close when clicking the close button, not when clicking the mega menu item again after it's been opened. 
        // As such, it was very difficult to come up with a "toggleAriaExpanded" function which would've really cut down on the duplication of code :/
        function toggleAriaExpandedCallBtn() {
            if ($(this).attr("aria-expanded") === "false") {
                $(this).attr("aria-expanded", "true");
            } else {
                $(this).attr("aria-expanded", "false");
            }
        }

        function setAriaExpandedTrue() {
            if ($(this).attr("aria-expanded") === "false") {
                $(this).attr("aria-expanded", "true");
            }
        }

        function setMegaMenuAriaExpandedFalse() {
            $(this).parents('.menu-item--mega').find('button').attr('aria-expanded', 'false');
        }

        // Hacky accessibility fix for screen readers to read out how many items there are in a collapsible mega menu when they focus on it
        // Definitely not a great fix - couldn't think of another solution :/
        megaMenuBtns.each(function () {
            var megaMenuLiCount = $(this).next().find("div[role='listitem']").length;
            var currentBtnText = $(this).text();
            $(this).attr('aria-label', currentBtnText + ", " + "expandable menu with " + megaMenuLiCount + " items.");
        });

        // Event Handlers
        megaMenuBtns.click(setAriaExpandedTrue);
        callBtn.click(toggleAriaExpandedCallBtn);
        megaMenuCloseBtns.click(setMegaMenuAriaExpandedFalse);
    });
})(jQuery);